// extracted by mini-css-extract-plugin
export default {"menuControls":"c-a_ey","menuControls_styleDefault":"c-a_ez","menuControls_styleRed":"c-a_eA"};